package com.bikompanion.data.analytics

import dev.zacsweers.metro.ContributesBinding
import dev.zacsweers.metro.Inject
import com.bikompanion.domain.analytics.AnalyticsEvent
import com.bikompanion.domain.analytics.AnalyticsTracker
import com.bikompanion.domain.di.AppScope

@ContributesBinding(AppScope::class)
@Inject
class AnalyticsTrackerImpl : AnalyticsTracker {
    override fun track(event: AnalyticsEvent) {
        runCatching { trackPlatformEvent(event) }
    }
}
